module.exports = __webpack_public_path__ + "static/media/lucvstattoo.e1c934db.png";